import { AppointmentGuideStruct } from "../../structs/private-billing/appointment-guide.struct";

export class AppointmentGuideRequest {
    public appointmentGuideStruct: AppointmentGuideStruct;
}